import { getLocalObj } from 'eco-design-reliance/i18n';
import { getTraceId } from './getTraceId';

export const getReqHeaders = (locale: string) => {
    const item = getLocalObj(locale);

    return {
        'X-Appid': item.appId,
        'Accept-Language': item.acceptLanguage,
        Traceid: getTraceId(),
    } as any;
};
